import { useState, useCallback } from "react";
import {
  createCustomerGroup,
  updateCustomerGroup,
  updateCustomerGroupMemberships,
} from "@api";

export function useGroupSave() {
  const [saving, setSaving] = useState(false);

  const saveGroup = useCallback(
    async ({
      name,
      selectedAccounts = [],
      selectAll = false,
      excludeCustomerIds = [],
      editingGroupId,
    }) => {
      setSaving(true);

      try {
        let groupId;

        if (editingGroupId) {
          const updatedGroup = await updateCustomerGroup(editingGroupId, {
            name,
          });
          if (!updatedGroup) {
            console.error("Failed to update group");
            return false;
          }
          groupId = editingGroupId;
        } else {
          const group = await createCustomerGroup({ name });
          if (!group) {
            console.error("Failed to create group");
            return false;
          }
          groupId = group.id;
        }

        const customerIds = selectAll
          ? []
          : selectedAccounts.map((account) => account.id);
        const success = await updateCustomerGroupMemberships(groupId, {
          customerIds,
          selectAll,
          excludeCustomerIds,
        });

        if (!success) {
          console.error("Failed to update group memberships");
          return false;
        }

        return groupId;
      } catch (error) {
        console.error("Error saving group:", error);
        return false;
      } finally {
        setSaving(false);
      }
    },
    [],
  );

  return {
    saving,
    saveGroup,
  };
}
